import React from "react";
import ContentLoader from "../../components/contentLoader";
import heroImage from "../../images/lead2.jpg";

export default function Lead() {
  return (
    <>
      <div
        className="heroImage"
        style={{ backgroundImage: `url(${heroImage})` }}
      ></div>
      <div className="contentContainer">
        <ContentLoader docName={"lead-a-group"} />
      </div>
    </>
  );
}
